module.exports = __webpack_public_path__ + "static/media/bkm-express.df439778.svg";